import { motion } from 'framer-motion'
import { Loader2 } from 'lucide-react'
import ParticlesEffect from '../common/particles/ParticleEffect'

// const tips = [
//   'Recuerda: el café no es desayuno ☕',
//   'Si tienes dudas, pregunta. Si no, también.',
//   'Guardar tu trabajo evita perder tu trabajo 💾',
//   'Las reuniones podrían haber sido un correo 📧',
//   'Respira hondo antes de responder a ese correo',
//   'El lunes llega aunque no lo invites 📅',
//   'No olvides poner “Saludos” al final del correo',
//   'Si tu jefe te llama, responde con calma',
//   'El Excel no muerde, pero asusta 🧮',
//   'El mejor momento para tomar vacaciones es siempre 🏖️',
//   'Si el WiFi falla, reinicia tu fe en la tecnología',
//   'El almuerzo es sagrado, no lo sacrifiques 🍽️',
//   'El “para ayer” nunca es literal… ¿o sí?',
//   'Recuerda: el mute es tu amigo en reuniones',
//   'El trabajo en equipo funciona mejor con equipo',
//   'Si te equivocas, culpa al sistema (broma)',
//   'El viernes es el mejor día para ser productivo… o no',
//   'No olvides celebrar tus pequeños logros 🎉',
//   'La impresora sabe cuándo tienes prisa 🖨️',
//   'Si todo falla, reinicia (incluyéndote a ti mismo)',
//   'Si el reclutador solo te saluda, prepárate para esperar la info del puesto 🕒',
//   '¡Envía toda la info del puesto en el primer mensaje! 📄',
//   'Animate a prender cámara en las reuniones! 🎥',
// ]

function LoadingLayout() {
  return (
    <motion.div
      id="home-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="relative flex items-center flex-col min-h-screen justify-center z-10 overflow-hidden py-12 px-4 font-inter"
    >
      <Loader2 className="animate-spin h-8 w-8 " />
      {/* <h1 className="text-text-primary animate-bounce pt-4">{tips.sort(() => Math.random() - 0.5)[0]}</h1> */}
      <ParticlesEffect />
      <div className="bg-background-primary absolute inset-0 w-screen h-screen -z-10"></div>
    </motion.div>
  )
}

export default LoadingLayout
